import { useEffect, useState } from "react";
import useApi from "./useApi";
import { BotProfile } from "@/pages/Messaging/Bots/types";

export default function useBotProfiles(includeArchived = false) {
  const [botProfiles, setBotProfiles] = useState<BotProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      try {
        const url = includeArchived
          ? "BotProfiles/list?includeArchived=true"
          : "BotProfiles/list";
        const data = await (await api.messaging.get(url)).json();
        setBotProfiles(Array.isArray(data) ? data : []);
      } catch {
        setBotProfiles([]);
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, [api.messaging, includeArchived]);

  return { botProfiles, loading };
}
